<div class="refresh-bar" *ngIf="newGroupCount > 0 || newNoticeCount > 0">
  <span class="d-none d-md-inline d-md-none d-lg-inline">Received</span
  ><span *ngIf="newGroupCount > 0"
    >&nbsp;<span class="refresh-bar__counter"
      >{{ newGroupCount }}<span *ngIf="groupLimit">+</span></span
    >
    new error<span *ngIf="newGroupCount !== 1">s</span></span
  ><span *ngIf="newGroupCount > 0 && newNoticeCount > 0"> and</span
  ><span *ngIf="newNoticeCount > 0"
    >&nbsp;<span class="refresh-bar__counter"
      >{{ newNoticeCount }}<span *ngIf="noticeLimit">+</span></span
    >
    new occurrence<span *ngIf="newNoticeCount !== 1">s</span></span
  ><a class="btn btn-sm refresh-bar__btn" (click)="refresh()"
    ><i class="glyphicon glyphicon-refresh refresh-bar__icon"></i>&nbsp;<span
      class="d-none d-md-inline"
      >Refresh</span
    ></a
  >
</div>
